import { render } from "./ImportPesos.vue?vue&type=template&id=1b7955be"
import script from "./ImportPesos.vue?vue&type=script&lang=js"
export * from "./ImportPesos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__